module.exports = __webpack_public_path__ + "static/img/img-cp1-1.354bbb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp1-1.png
// module id = Ymd6
// module chunks = 0